import React from 'react';
export function IntegrationsBar() {
  const integrations = [{
    name: 'Jira',
    color: 'border-blue-500'
  }, {
    name: 'Confluence',
    color: 'border-blue-400'
  }, {
    name: 'Slack',
    color: 'border-purple-500'
  }, {
    name: 'Notion',
    color: 'border-slate-300'
  }, {
    name: 'GitHub',
    color: 'border-slate-100'
  }, {
    name: 'Google Workspace',
    color: 'border-emerald-500'
  }];
  return <div className="bg-slate-900/50 border-y border-slate-800 py-6 overflow-hidden" data-id="element-260">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12" data-id="element-262">
          <p className="text-slate-400 font-medium whitespace-nowrap flex-shrink-0" data-id="element-263">
            Connects with your entire stack →
          </p>

          <div className="flex items-center gap-4 overflow-x-auto pb-2 md:pb-0 w-full hide-scrollbar mask-edges" data-id="element-264">
            {integrations.map(integration => <div key={integration.name} className={`flex-shrink-0 flex items-center bg-slate-800/50 rounded-full px-4 py-2 border-l-2 ${integration.color} border-y border-r border-y-slate-700 border-r-slate-700`} data-id="element-265">
                <span className="text-sm font-medium text-slate-300" data-id="element-266">
                  {integration.name}
                </span>
              </div>)}
          </div>
        </div>
      </div>
      <style data-id="element-267">{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        .mask-edges {
          mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
        }
      `}</style>
    </div>;
}